import React from "react";

class Setting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        } 
    }

    render() {
        return (
            <div className="skeleton">
                <div style={{width:"48%",height:50,borderRadius:"10px 10px 0 0",marginBottom:1}}
                    className="table">
                    <div className="middle">
                        <div style={{width:360,height:16,marginTop:3,float:'left'}}/>
                        <div style={{width:22,height:22,float:'right'}}/>
                    </div>
                </div>
                <div style={{width:"48%",height:50,borderRadius:"0 0 10px 10px",marginBottom:50}}
                    className="table">
                    <div className="middle">
                        <div style={{width:360,height:16,marginTop:3,float:'left'}}/>
                        <div style={{width:22,height:22,float:'right'}}/>
                    </div>
                </div>
                <div style={{width:"48%",height:50,borderRadius:10}} className="table">
                    <div className="middle">
                        <div style={{width:180,height:16,marginTop:3,float:'left'}}/>
                        <div style={{width:83,height:16,marginTop:3,float:'right'}}/>
                    </div>
                </div>                
            </div> 
        )
    }
}

export default Setting;
